import { Head } from '@inertiajs/react';
import type { ArcadeHack25SubmissionsShow } from '@/types';
import { ArcadeScreen } from '../components/arcade-screen';
import { SubmitForm } from './components/submit-form';

export default function Show({ repo, validation }: ArcadeHack25SubmissionsShow) {
  return (
    <>
      <Head title="Platanus Hack 25 Arcade">
        <meta
          name="description"
          content="Vibecode the hackathon arcade, get 250 usd"
        />
      </Head>
      <div className="min-h-screen bg-black">
        <ArcadeScreen intensity="medium">
          <SubmitForm repo={repo} validation={validation} />
        </ArcadeScreen>
      </div>
    </>
  );
}
